import { api, apiAxiosInstance } from './api';

export const fetchUsers = (params, options) => {
  return api.get('/user', params, options);
};

export const fetchUsersStatus = () => {
  return api.get('/user/driver_statuses');
};

export const fetchUserById = (id) => {
  return api.get(`/user/${id}`);
};

export const fetchDeleteUser = (id, payload) => {
  return apiAxiosInstance
    .delete(`/user/${id}`, {
      data: { ...payload },
    })
    .catch((err) => err.response);
};

export const fetchEmailConfirm = (payload) => {
  return api.post('/auth/email_confirm', payload);
};

export const fetchSendPasswordReset = (payload) => {
  return api.post('/auth/password_reset', payload);
};

export const fetchPhoneConfirm = (payload) => {
  const url = payload.params ? `/auth/phone_confirm/${payload.params}` : '/auth/phone_confirm';
  return api.post(url, payload);
};

export const fetchUpdateUserStatus = (id, payload) => {
  return api.put(`/user/${id}/update_status`, payload);
};

export const fetchUpdateUserRole = (id, payload) => {
  return api.put(`/user/${id}/role`, payload);
};

export const fetchUserVehicleGroups = (id, params) => {
  return api.get(`/user/${id}/vehicle_group`, params);
};

export const fetchAddUserVehicleGroups = (id, payload) => {
  return api.post(`/user/${id}/vehicle_group`, payload);
};

export const fetchDeleteUserVehicleGroups = (id, goupId) => {
  return api.delete(`/user/${id}/vehicle_group/${goupId}`);
};

export const fetchDeleteUserGroups = (id, goupId) => {
  return api.delete(`/user/${id}/user_group/${goupId}`);
};

export const fetchUpdateUser = (id, payload) => {
  return api.put(`/user/${id}`, payload);
};

export const fetchUpdateUserQualifications = (id, payload) => {
  return api.post(`/user/${id}/qualification`, payload);
};

export const fetchUserPrivileges = (id) => {
  return api.get(`/user/${id}/privileges`);
};

export const fetchAddNfcCard = (payload) => {
  return api.post('/access_device/broker ', payload);
};

export const fetchUserGroups = (id, params) => {
  return api.get(`/user/${id}/user_group`, params);
};

export const fetchAddUserGroups = (id, userGroup) => {
  return api.post(`/user/${id}/user_group`, { group_id: userGroup });
};

export const getAccountBrokers = (id) => {
  return api.get(`/account/${id}/broker_keys`);
};

export const fetchDeletionUser = (id, body) => {
  return api.post(`/user/${id}/deletion_request`, body);
};
